import { canvasProps } from "@/utils/constants/canvasProps";
import { FrameOptionsProps } from "@/utils/constants/frameOptionsDefault";
import { frameProps } from "@/utils/constants/frameProps";
import { hdAluProps } from "@/utils/constants/hdAluProps";
import { PaperOptionsProps } from "@/utils/constants/paperOptionsDefault";

export type ProductType = (typeof PRODUCT_TYPE)[keyof typeof PRODUCT_TYPE];
export type ProductOptions = {
  display: boolean;
  frameOptions: Partial<FrameOptionsProps>;
  paperOptions: Partial<PaperOptionsProps>;
  treatmentOptions: Partial<{
    subcategory: string;
    type: string;
  }>;
  finish: string;
  /** Staff mount-only spec (utils/content/mountOnly.ts); absent / null on every other treatment. */
  mountOnly?: import("@/utils/content/mountOnly").MountOnlySpec | null;
};
export type ProductTypeConfig = {
  title: string;
  // image: string;
  label: string;
  color: string;
  options: Partial<ProductOptions>;
  steps: string[];
  description: string;
};

export const PRODUCT_TYPE = {
  GICLEE: "Giclee",
  CANVAS: "Canvas",
  HD_ALUMINUM: "HD Aluminum",
} as const;

export const PRODUCT_TYPE_PROPS = {
  [PRODUCT_TYPE.GICLEE]: {
    label: PRODUCT_TYPE.GICLEE,
    title: "Fine Art Giclee",
    color: "giclee",
    options: frameProps,
    steps: [
      "Choose Your Product",
      "Image Size and Cropping",
      "Paper",
      "Finishing & Framing",
    ],
    description:
      "Museum-quality fine art prints on premium archival paper, perfect for collectors and art enthusiasts seeking exceptional detail and longevity.",
  },
  [PRODUCT_TYPE.CANVAS]: {
    title: "Canvas Giclee",
    label: PRODUCT_TYPE.CANVAS,
    color: "canvas",
    options: canvasProps,
    steps: [
      "Choose Your Product",
      "Canvas Image Size and Cropping",
      "Canvas Type",
      // "Canvas Edge Option",
      "Canvas Finishing & Framing Options",
    ],
    description:
      "Gallery-wrapped canvas prints that bring depth and texture to your space, ideal for a classic yet contemporary look that doesn't require glass.",
  },
  [PRODUCT_TYPE.HD_ALUMINUM]: {
    label: PRODUCT_TYPE.HD_ALUMINUM,
    title: "HD Aluminum",
    color: "hdalu",
    options: hdAluProps,
    steps: [
      "Choose Your Product",
      "HD Aluminum Image Size and Cropping",
      "HD Aluminum Finish",
      "HD Aluminum Framing Option",
    ],
    description:
      "Stunning metal prints with vibrant colors and luminous qualities, creating a modern, floating appearance perfect for contemporary spaces.",
  },
} satisfies Record<ProductType, ProductTypeConfig>;
